import {
  PaymentMethod,
  InstallmentStatus,
  InstallmentType,
} from '@/app/shared/enums';
import { Model } from '@/app/shared/models/model';
import { PaymentInfoModel, ReferenceModel } from '@/app/shared/models';

export class InstallmentModel extends Model {
  public PaymentMethod?: PaymentMethod;
  public Status!: InstallmentStatus;
  public OriginalDueDate?: Date | string;
  public CurrentAttemptNumber?: number;
  public Value?: number;
  public Number?: number;
  public CurrencyCode?: string;
  public OurCode?: string;
  public YearReference?: number;
  public MonthReference?: number;
  public YearMonthReference?: string;
  public Reference?: ReferenceModel;
  public PartialValue?: number;
  public TotalValueRefunds?: number;
  public ProcessorPartialRefund?: boolean = false;
  public HasOriginalTransactionInstallment?: boolean = false;
  public ChargeBackHistory?: string[] | InstallmentModel[] = [];
  public Message?: string;

  public InstallmentType!: InstallmentType;

  public PaymentInfos?: PaymentInfoModel[];

  constructor() {
    super();
    this.InstallmentType = InstallmentType.Ordinary;
  }
}
